import * as Sentry from '@sentry/react'
import type { BrowserOptions } from '@sentry/react'
import { BUILD_VERSION } from '~/client/common/build-info'
import { beforeSend } from '~/shared/common/sentry/before-send'

// The DSN is read from the VITE_SENTRY_DSN env var (set in all deploy workflows).
// The literal fallback ensures no hard break while the env var rolls out to all environments.
const DSN_FALLBACK = 'https://a7d2eaebbd9e4907a8683544ec719e1e@o4510283696570368.ingest.us.sentry.io/4510284021956608'

export const sentryConfig: BrowserOptions = {
  dsn: import.meta.env.VITE_SENTRY_DSN ?? DSN_FALLBACK,
  // Emit release only when a real commit hash is present (avoids "dev" noise in Sentry UI)
  release: BUILD_VERSION && BUILD_VERSION !== 'dev' ? BUILD_VERSION : undefined,
  environment: import.meta.env.VITE_ENV_ROLE ?? 'branch-preview',
  sendDefaultPii: false,
  tracesSampleRate: 0,
  // We own unhandledrejection reporting in sentry-bootstrap.ts; disable the SDK's default
  // handler here so we don't emit duplicate events.
  integrations: (defaults) =>
    defaults.map((integration) =>
      integration.name === 'GlobalHandlers'
        ? Sentry.globalHandlersIntegration({ onerror: true, onunhandledrejection: false })
        : integration,
    ),
  beforeSend,
  initialScope: {
    tags: { runtime: 'client' },
  },
}
